import React from "react";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import PostsComponent from "../../components/Post";

export default function Articles() {
  return (
    <div>
      <Navbar />
      <div className="hidden md:block bg-[#F7F7F7] h-[80px]"></div>
      <div className="bg-about h-[80px] md:h-[300px] bg-contain bg-no-repeat md:bg-cover flex flex-col justify-center items-center">
        <h2 className="text-center mx-auto text-white text-2xl md:text-6xl ">
          Articles
        </h2>
      </div>
      <PostsComponent category={"articles"} />
      <Footer />
    </div>
  );
}
